import axios from 'axios'
import config from '@/config'
import { Message } from 'element-ui'

// 创建axios实例
const request = axios.create({
    baseURL: config.baseURL,
    timeout: 30000,  // 增加到30秒，给后端更多响应时间
    validateStatus: function (status) {
        return status >= 200 && status < 300
    }
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        // 确保 config 和 url 存在且有效
        if (config && config.url) {
            // 如果不是完整的 http URL，则确保以 / 开头
            if (!config.url.startsWith('http')) {
                config.url = config.url.startsWith('/') ? config.url : '/' + config.url
            }
        }
        return config
    },
    error => {
        console.error('请求错误:', error)
        Message.error('网络请求失败，请检查您的网络连接')
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        // 直接返回原始响应，让组件自己处理
        return response
    },
    error => {
        console.error('响应错误详情:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                baseURL: error.config?.baseURL
            }
        })
        if (error.response) {
            if (error.response.status === 400) {
                // 让业务侧自行处理 400 提示，避免重复提示
                return Promise.reject(error)
            }
            // 服务器返回了错误状态码
            switch (error.response.status) {
                case 404:
                    Message.error('请求的资源不存在')
                    break
                case 500:
                    Message.error('服务器内部错误')
                    break
                default:
                    Message.error('请求失败，请稍后重试')
            }
        } else if (error.code === 'ECONNABORTED') {
            Message.error('请求超时，请检查您的网络连接')
        } else {
            Message.error('网络连接失败，请检查您的网络设置')
        }
        // 返回完整的错误信息，而不是截断的错误
        return Promise.reject(new Error(`API请求失败: ${error.message} (状态码: ${error.response?.status || 'N/A'})`))
    }
)

export default request 